import "./Inbox.scss";

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import AppHeader from "../../components/AppHeader";
import { getMailBox } from "../../services/api";
import Inbox from "./Inbox";

export default function InboxContainer() {
  const [state, setState] = useState({
    loading: true,
    error: false,
    data: null
  });

  const { mailBoxName, listingId, homeCode } = useParams();
  const cancelRequestRef = useRef(null);

  const cancelPendingRequest = message => {
    if (cancelRequestRef.current) {
      cancelRequestRef.current.cancel(message);
      cancelRequestRef.current = null;
    }
  };

  const getInbox = () => {
    cancelRequestRef.current = axios.CancelToken.source();
    setState(prevState => ({ ...prevState, loading: true }));

    getMailBox(mailBoxName, listingId, cancelRequestRef.current.token)
      .then(({ data }) => {
        setState({
          data,
          loading: false,
          error: false
        });
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return console.info(error.message);
        }

        setState(prevState => ({
          ...prevState,
          loading: false,
          error
        }));
      });
  };

  useEffect(() => {
    getInbox();

    return () => {
      cancelPendingRequest(
        "This request was pending after the component unmounted."
      );
    };
  }, [mailBoxName, listingId]);

  return (
    <React.Fragment>
      <AppHeader title={`Inbox for: ${mailBoxName}`} />

      <Inbox
        state={state}
        mailBoxName={mailBoxName}
        listingId={listingId}
        homeCode={homeCode}
      />
    </React.Fragment>
  );
}
